module.exports = (typeof console != 'undefined') && console